import React, { useEffect, useState } from "react";
import { getCanonicalJson } from "../api/canonicalService";

export default function JsonViewerModal({ row, onClose }) {
  const [json, setJson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    setJson(null);
    getCanonicalJson(row.id)
      .then((data) => {
        if (!cancelled) {
          try {
            setJson(JSON.stringify(JSON.parse(data.json), null, 2));
          } catch {
            setJson(data.json);
          }
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setError("Failed to load canonical payload.");
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [row]);

  const handleCopy = () => {
    navigator.clipboard.writeText(json || "").then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      className="modal-overlay"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="modal-content">
        <div className="modal-header">
          <div className="modal-title">
            <strong>{row.entityType}</strong>
            <span className="modal-meta"> &mdash; {row.entityId}</span>
            {row.correlationId && (
              <span className="modal-meta"> &nbsp;|&nbsp; Corr: {row.correlationId}</span>
            )}
          </div>
          <div className="modal-actions">
            {json && (
              <button className="btn-secondary" onClick={handleCopy}>
                {copied ? "Copied!" : "Copy JSON"}
              </button>
            )}
            <button className="btn-close" onClick={onClose}>
              &#x2715;
            </button>
          </div>
        </div>
        <div className="xml-viewer-wrap">
          {loading && <div className="xml-loading">Loading&hellip;</div>}
          {error && <div className="payload-error">{error}</div>}
          {!loading && !error && !json && (
            <div className="xml-loading">No canonical payload found for this record.</div>
          )}
          {json && (
            <pre className="json-pre">{json}</pre>
          )}
        </div>
      </div>
    </div>
  );
}
